import { defineNuxtPlugin } from '#app/nuxt'
import { LazyThankYouMessage, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ThankYouMessage", LazyThankYouMessage],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
